// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2Gewd","empty":"ModalGraph_empty__2EXNP"};